module.exports = __webpack_public_path__ + "img/user-circle-phone-icon.svg";